import React from 'react';

const ConfirmationModal = ({
    isOpen,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    onCancel,
    type = "danger" // danger, warning, info
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content shadow-lg border-0">
                    <div className={`modal-header ${type === 'danger' ? 'bg-danger-subtle text-danger' : 'bg-light'}`}>
                        <h5 className="modal-title fw-bold">
                            {type === 'danger' && <i className="bi bi-exclamation-triangle-fill me-2"></i>}
                            {title}
                        </h5>
                        <button type="button" className="btn-close" onClick={onCancel} aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-4">
                        <p className="mb-0 fs-5">{message}</p>
                    </div>
                    <div className="modal-footer border-top-0">
                        <button type="button" className="btn btn-light px-4" onClick={onCancel}>
                            {cancelLabel}
                        </button>
                        <button
                            type="button"
                            className={`btn btn-${type} px-4 fw-bold`}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
